exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-uploadFile[data-v-6991fd44]{border:2px dashed #c5c4c4;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:360px;overflow-y:auto}.new-uploadFile[data-v-6991fd44] .el-upload-dragger{height:200px!important}", ""]);

// exports
